import { API_BASE_URL } from './apiConfig';
import { fetchWithRetry } from './network';

export const loadOutletStockCatalog = async (user, signal) => {
  const admin = ['ADMIN', 'DIRECTOR'].includes(String(user.role || '').toUpperCase());
  // The standard catalog holds Gollavelli/Ravulacheruvu; Vadaparru has its own collection.
  const locations = admin ? ['GOLLAVELLI', 'VADAPARRU'] : [null];
  const catalogs = await Promise.all(locations.map(async location => {
    const query = new URLSearchParams({ includeFinancials: 'true' });
    if (location) query.set('location', location);
    const response = await fetchWithRetry(`${API_BASE_URL}/pos-products/catalog?${query}`, {
      headers: { Authorization: `Bearer ${user.token}` }, cache: 'no-store', signal,
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || data.error || 'Unable to load outlet stock');
    return Array.isArray(data) ? data : data.products || [];
  }));
  return catalogs.flat();
};
